import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getAllSets = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 9999,
  sort = [],
  locationId = "",
  areaId = "",
  role,
  allIds
) => {
  let setFilter = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
  };

  if (locationId && areaId) {
    setFilter.$or = [
      {
        parts: {
          part: {
            inventory: {
              $and: [
                {
                  location: {
                    id: {
                      $eq: locationId,
                    },
                  },
                },
                {
                  area: {
                    id: {
                      $eq: areaId,
                    },
                  },
                },
              ],
            },
          },
        },
      },
      {
        sets: {
          set: {
            parts: {
              part: {
                inventory: {
                  $and: [
                    {
                      location: {
                        id: {
                          $eq: locationId,
                        },
                      },
                    },
                    {
                      area: {
                        id: {
                          $eq: areaId,
                        },
                      },
                    },
                  ],
                },
              },
            },
          },
        },
      },
    ];
  }

  if (!(role === "super_admin")) {
    setFilter.location = {
      id: {
        $in: allIds,
      },
    };
  }

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: setFilter,
    _q: searchName,
    populate: [
      "createdByUser",
      "createdByUser.profileImage",
      "updatedByUser",
      "updatedByUser.profileImage",
      "sets",
      "parts",
      "location",
      "parts.part",
      "parts.part.inventory.location",
      "parts.part.inventory.area",
      "sets.set",
      "sets.set.parts",
      "sets.set.parts.part",
      "sets.set.parts.part.inventory",
      "sets.set.parts.part.inventory.location",
      "sets.set.parts.part.inventory.area",
      "organisation",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `sets?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    return dataObj;
  } catch (err) {
    if (err.response) {
      return err.response.data;
    } else if (err.request) {
    } else {
    }
  }
};
